export default {"src":"/_next/static/media/play.9f237d55.svg","height":24,"width":24};